import { Node, Nodes } from "../types";

/**
 * Возвращает массив значений `value` всех листовых нод, полученных из исходного массива нод.
 * Листовая нода - это нода, не имеющая дочерних нод.
 *
 * @param nodes - Исходный массив нод.
 * @returns Массив значений `value` всех листовых нод.
 */
export const getLeaves = (nodes: Nodes) => {
  const leaves: string[] = [];

  function traverse(node: Node) {
    if (node.nodes) {
      node.nodes.forEach(traverse);
    } else if (node.value) {
      leaves.push(node.value);
    }
  }

  nodes.forEach(traverse);

  return leaves;
};
